export type ImagesKeys =
  | "smallLogo"
  | "leftArrow"
  | "hamburger"
  | "mail"
  | "eye"
  | "greenCheckMark"
  | "search"
  | "close"
  | "arrow"
  | "contact"
  | "delete"
  | "duplicate"
  | "rename"
  | "more"
  | "greenCheckMark"
  | "earth"
  | "earthGreen"
  | "units"
  | "unitsGreen"
  | "user"
  | "userGreen"
  | "navAbout"
  | "navAboutActive"
  | "navAgri"
  | "navAgriActive"
  | "navContact"
  | "navContactActive"
  | "navSavedItems"
  | "navSavedItemsActive"
  | "navSolution"
  | "navSolutionActive"
  | "stepCrop"
  | "stepCropActive"
  | "stepCustomize"
  | "stepCustomizeActive"
  | "stepFarm"
  | "stepFarmActive"
  | "stepResult"
  | "stepResultActive"
  | "stepSoil"
  | "stepSoilActive"
  | "bigLogo"
  | "saveProcess"
  | "update"
  | "reset"
  | "deleteWhite"
  | "renameWhite"
  | "actionWhite"
  | "share"
  | "skip"
  | "whiteClose"
  | "zigit"
  | "facebook"
  | "linkedin"
  | "leaves"
  | "error"
  | "eyeShow"
  | "pdfFooter"
  | "pdfLogo"
  | "close_popup"
  | "vi_popup"
  | "clearModalImage"
  | "precisionImpactImage"
  | "errorApiModal"
  | "co2Logo"
  | "tiltedCo2Logo"
  | "whitePlus"
  | "filledUpArrow"
  | "helpCircle"
  | "carbonTableLeaf"
  | "simaproLogo"
  | "stepWithCO2";

export type ImageType = {
  [key in ImagesKeys]: string;
};

export const images: ImageType = {
  smallLogo: "/multi-match/Assets/Icons/smallLogo.svg",
  leftArrow: "/multi-match/Assets/Icons/leftArrow.svg",
  hamburger: "/multi-match/Assets/Icons/hamburger.svg",
  mail: "/multi-match/Assets/Icons/mail.svg",
  eye: "/multi-match/Assets/Icons/eye.svg",
  greenCheckMark: "/multi-match/Assets/Icons/greenCheckMark.svg",
  search: "/multi-match/Assets/Icons/search.svg",
  close: "/multi-match/Assets/Icons/close.svg",
  arrow: "/multi-match/Assets/Icons/arrow.svg",
  contact: "/multi-match/Assets/Icons/contact.svg",
  delete: "/multi-match/Assets/Icons/delete.svg",
  duplicate: "/multi-match/Assets/Icons/duplicate.svg",
  rename: "/multi-match/Assets/Icons/rename.svg",
  more: "/multi-match/Assets/Icons/more.svg",
  earth: "/multi-match/Assets/Icons/earth.svg",
  units: "/multi-match/Assets/Icons/units.svg",
  user: "/multi-match/Assets/Icons/user.svg",
  earthGreen: "/multi-match/Assets/Icons/earth.png",
  unitsGreen: "/multi-match/Assets/Icons/units.png",
  userGreen: "/multi-match/Assets/Icons/user.png",
  navAbout: "/multi-match/Assets/Icons/Nav/about.svg",
  navAboutActive: "/multi-match/Assets/Icons/Nav/aboutActive.svg",
  navAgri: "/multi-match/Assets/Icons/Nav/agri.svg",
  navAgriActive: "/multi-match/Assets/Icons/Nav/agriActive.svg",
  navContact: "/multi-match/Assets/Icons/Nav/contact.svg",
  navContactActive: "/multi-match/Assets/Icons/Nav/contactActive.svg",
  navSavedItems: "/multi-match/Assets/Icons/Nav/savedItems.svg",
  navSavedItemsActive: "/multi-match/Assets/Icons/Nav/savedItemsActive.svg",
  navSolution: "/multi-match/Assets/Icons/Nav/solution.svg",
  navSolutionActive: "/multi-match/Assets/Icons/Nav/solutionActive.svg",
  stepCrop: "/multi-match/Assets/Icons/Steps/crop.svg",
  stepCropActive: "/multi-match/Assets/Icons/Steps/cropActive.svg",
  stepCustomize: "/multi-match/Assets/Icons/Steps/customize.svg",
  stepCustomizeActive: "/multi-match/Assets/Icons/Steps/customizeActive.svg",
  stepFarm: "/multi-match/Assets/Icons/Steps/farm.svg",
  stepFarmActive: "/multi-match/Assets/Icons/Steps/farmActive.svg",
  stepResult: "/multi-match/Assets/Icons/Steps/result.svg",
  stepResultActive: "/multi-match/Assets/Icons/Steps/resultActive.svg",
  stepSoil: "/multi-match/Assets/Icons/Steps/soil.svg",
  stepSoilActive: "/multi-match/Assets/Icons/Steps/soilActive.svg",
  bigLogo: "/multi-match/Assets/Icons/bigLogo.svg",
  saveProcess: "/multi-match/Assets/save_image.png",
  update: "/multi-match/Assets/Icons/update.svg",
  reset: "/multi-match/Assets/Icons/reset.svg",
  renameWhite: "/multi-match/Assets/Icons/renameWhite.svg",
  deleteWhite: "/multi-match/Assets/Icons/deleteWhite.svg",
  actionWhite: "/multi-match/Assets/Icons/actionWhite.svg",
  share: "/multi-match/Assets/Icons/share.svg",
  skip: "/multi-match/Assets/Icons/skip.svg",
  whiteClose: "/multi-match/Assets/Icons/whiteClose.svg",
  zigit: "/multi-match/Assets/Icons/zigit.svg",
  linkedin: "/multi-match/Assets/Icons/linkedin.svg",
  facebook: "/multi-match/Assets/Icons/facebook.svg",
  leaves: "/multi-match/Assets/Icons/leaves.svg",
  error: "/multi-match/Assets/Icons/error.svg",
  eyeShow: "/multi-match/Assets/Icons/eyeShow.svg",
  close_popup: "/multi-match/Assets/Icons/close_popup.svg",
  vi_popup: "/multi-match/Assets/Icons/vi_popup.svg",
  pdfFooter: "/multi-match/Assets/pdf/Footer_.png",
  pdfLogo: "/multi-match/Assets/pdf/Logo.png",
  errorApiModal: "/multi-match/Assets/Modals/ApiErrorModal/error_image.png",
  clearModalImage: "/multi-match/Assets/clear_image.png",
  precisionImpactImage: "/multi-match/Assets/precisionImpact.png",
  co2Logo: "/multi-match/Assets/Icons/co2_logo.svg",
  tiltedCo2Logo: "/multi-match/Assets/Icons/tiltedco2logo.svg",
  stepWithCO2: "/multi-match/Assets/Icons/stepwithCo2.svg",
  whitePlus: "/multi-match/Assets/Icons/whitePlus.svg",
  filledUpArrow: "/multi-match/Assets/Icons/filledArrow.svg",
  helpCircle: "/multi-match/Assets/Icons/help-circle.svg",
  carbonTableLeaf: "/multi-match/Assets/carbon-table-leaf.svg",
  simaproLogo: "/multi-match/Assets/simapro.png",
};
